import React from 'react';
import { motion } from 'framer-motion';
export function WhatYouLearn() {
  const learnings = [{
    emoji: '🔥',
    title: 'Convertir el ghosting en persecución',
    desc: '(Cambio de energía en 1 a 7 días)'
  }, {
    emoji: '🧠',
    title: 'El interruptor psicológico',
    desc: 'que hace que él invierta, persiga y no quiera perderte'
  }, {
    emoji: '💬',
    title: 'Exactamente qué responder',
    desc: 'cuando él se aleja o baja la intensidad'
  }, {
    emoji: '👑',
    title: 'Confianza femenina letal',
    desc: 'que genera respeto y atracción inmediata'
  }, {
    emoji: '💘',
    title: 'Hacer que ÉL te persiga primero',
    desc: '(mensajes, llamadas, planes y esfuerzo)'
  }];
  return <section className="py-14 bg-deep-black text-white" data-id="element-243">
      <div className="max-w-4xl mx-auto px-6" data-id="element-244">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-245">
          <h2 className="text-3xl sm:text-4xl font-playfair mb-4" data-id="element-246">
            Lo que vas a{' '}
            <span className="italic text-bordeaux-vivid" data-id="element-247">aprender</span>
          </h2>
          <div className="w-16 h-0.5 bg-bordeaux-vivid mx-auto" data-id="element-248"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10" data-id="element-249">
          {learnings.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1,
          duration: 0.5
        }} className="flex items-start bg-white/5 p-6 border border-white/10 hover:border-bordeaux-vivid/60 transition-colors" data-id="element-250">
              <span className="text-2xl mr-4 flex-shrink-0 mt-0.5 leading-none" aria-hidden="true" data-id="element-251">
                {item.emoji}
              </span>
              <div data-id="element-252">
                <h4 className="font-inter font-bold text-lg mb-1" data-id="element-253">
                  {item.title}
                </h4>
                <p className="font-inter text-gray-400 text-sm" data-id="element-254">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="mt-6 flex justify-center" data-id="element-255">
          <img src="https://cdn.magicpatterns.com/uploads/nGRgLdT8Gcd8AjDeLPixER/Captura_de_pantalla_2026-05-11_a_la(s)_8.07.20_p._m..png" alt="Hombre trayendo un ramo de rosas rojas, persiguiendo a la mujer" className="w-full max-w-md lg:max-w-lg h-auto rounded-sm shadow-2xl" data-id="element-256" />
        </motion.div>
      </div>
    </section>;
}